module.exports = __webpack_public_path__ + "media/src/images/site-top/icon-toyama-lg-636771e0b9013f97b21487f1360e582a.png";